export const USER_IMPRESSION_GROUP = 'user_impressions';
export const USER_IMPRESSION_SUB_GROUP = 'view_impression';
export const IMPRESSION_TYPE = 'impression';
export const FEATURE_NAME = 'workspace';
export const PAGE_NAME = 'workspace';
export const PAGE_VIEW = 'page_view';
